"use client";
import { Button } from "@/components/ui/button";
import { Link } from "@/i18n/routing";
import { ArrowUpRight } from "@mynaui/icons-react";
import { sendGTMEvent } from "@next/third-parties/google";

export default function HeroPageButton({ text, location }) {
  const link =
    2 === "authenticated"
      ? location !== "/"
        ? `/profile/${location}`
        : `/profile/scanner`
      : `/auth/signup`;
  return (
    <Link href={link} className="mt-4">
      <Button
        onClick={() => {
          sendGTMEvent({ event: "homepage_welcome_click_getstarted" });
        }}
        size="xl"
      >
        {text}
        <ArrowUpRight className="w-6 h-6 ml-2" />
      </Button>
    </Link>
  );
}
